export enum PickupOrderStatus {
  Pending = 'pending',
  FalseBarcode = 'false_barcode',
  Picked = 'picked',
  Processed = 'processed',
  Returned = 'returned',
}

export interface PickupOrder {
  id: string
  userId: string
  pickupDate: string
  orderNumber: string
  barcodeImg: string
  warehouse: string
  status: PickupOrderStatus
  createdAt: string
}

export interface CreatePickupOrderPayload {
  pickupDate: string
  orderNumber: string
  barcodeFile: File | null
}
